module.exports = __webpack_public_path__ + "img/certificate04-6.7e085779.jpg";